import { COLORS } from './app.constants';
import poiAttractions from '@sodraberget/shared/src/assets/images/icons/pois/poi-attractions.svg';
import poiBusStop from '@sodraberget/shared/src/assets/images/icons/pois/poi-bus-stop.svg';
import poiCabin from '@sodraberget/shared/src/assets/images/icons/pois/poi-cabin.svg';
import poiCafe from '@sodraberget/shared/src/assets/images/icons/pois/poi-cafe.svg';
import poiIceRink from '@sodraberget/shared/src/assets/images/icons/pois/poi-ice-rink.svg';
import poiParking from '@sodraberget/shared/src/assets/images/icons/pois/poi-parking.svg';
import poiPlaceOfInterest from '@sodraberget/shared/src/assets/images/icons/pois/poi-place-of-interest.svg';
import poiRestaurants from '@sodraberget/shared/src/assets/images/icons/pois/poi-restaurants.svg';
import poiShelter from '@sodraberget/shared/src/assets/images/icons/pois/poi-shelter.svg';
import poiStore from '@sodraberget/shared/src/assets/images/icons/pois/poi-store.svg';
import poiSwimming from '@sodraberget/shared/src/assets/images/icons/pois/poi-swimming.svg';
import poiToilets from '@sodraberget/shared/src/assets/images/icons/pois/poi-toilets.svg';
import poiViewpoints from '@sodraberget/shared/src/assets/images/icons/pois/poi-viewpoints.svg';
import poiWarnings from '@sodraberget/shared/src/assets/images/icons/pois/poi-warning.svg';

const MAPBOX_ACCESS_TOKEN = process.env.REACT_APP_MAPBOX_ACCESS_TOKEN || 'pk.eyJ1IjoibGV2ZWw1LXNlIiwiYSI6ImNsbDIxMDd1ZjBqMHUzZXM3b2xicncyd3kifQ.YjWtfT-flmFUAfiajCcDpA';
const MAPBOX_STYLE_USER = process.env.REACT_APP_MAPBOX_STYLE_USER || 'level5-se';
const MAPBOX_STYLE_ID = process.env.REACT_APP_MAPBOX_STYLE_ID || 'cmvzsivhu00b101ry311kabnp';
const MAPBOX_3D_STYLE_USER = process.env.REACT_APP_MAPBOX_3D_STYLE_USER || 'level5-se';
const MAPBOX_3D_STYLE_ID = process.env.REACT_APP_MAPBOX_3D_STYLE_ID || 'cmvztnam100di01s84g2wdr2f';
const MAPBOX_SATELLITE_STYLE_USER = process.env.REACT_APP_MAPBOX_SATELLITE_STYLE_USER || 'level5-se';
const MAPBOX_SATELLITE_STYLE_ID = process.env.REACT_APP_MAPBOX_SATELLITE_STYLE_ID || 'cmvzseirq007q01r14jupadj6';
const MAPBOX_3D_SATELLITE_STYLE_USER = process.env.REACT_APP_MAPBOX_3D_SATELLITE_STYLE_USER || 'level5-se';
const MAPBOX_3D_SATELLITE_STYLE_ID = process.env.REACT_APP_MAPBOX_3D_SATELLITE_STYLE_ID || 'cmvzq8uyt00c001qp5o5yh2cp';

const ICONS = {
    PATHS: {
        CROSS_COUNTRY_SKIING: 'openlayers/icons/paths/path-cross-country-skiing.png',
        CROSS_COUNTRY_SKIING_CLOSED: 'openlayers/icons/paths/path-cross-country-skiing.png',
        SNOWMOBILING: 'openlayers/icons/paths/path-snowmobiling.png',
        MOUNTAIN_BIKING: 'openlayers/icons/paths/path-mountain-biking.png',
        HIKING: 'openlayers/icons/paths/path-hiking.png',
        ENDCAP: 'openlayers/icons/paths/path-endcap.png',
        RUNNING: 'openlayers/icons/paths/path-running.png',
        RIDING: 'openlayers/icons/paths/path-riding.png',
        CANOE: 'openlayers/icons/paths/path-canoe.png',
        CHAIR_LIFT: 'openlayers/icons/paths/path-chair-lift.png',
        GONDOLA: 'openlayers/icons/paths/path-gondola.png',
        SURFACE_LIFT: 'openlayers/icons/paths/path-surface-lift.png',
        BELT_LIFT: 'openlayers/icons/paths/path-belt-lift.png',
        SKI_SLOPE: 'openlayers/icons/paths/path-ski-slope.png',
    },
    POIS: {
        RESTAURANT: poiRestaurants,
        ATTRACTIONS: poiAttractions,
        PARKING: poiParking,
        LOOKOUTS: poiViewpoints,
        CAFES: poiCafe,
        CABINS: poiCabin,
        SKI_BUS: poiBusStop,
        SHELTER: poiShelter,
        STORES: poiStore,
        SNOWMOBILE_RENTAL: poiStore,
        SPORTS_RENTAL: poiStore,
        TOILETS: poiToilets,
        WARNINGS: poiWarnings,
        PLACE_OF_INTERESTS: poiPlaceOfInterest,
        ICE_RINK: poiIceRink,
        SWIMMING_PLACES: poiSwimming,
        TEMPERATURE: 'openlayers/icons/pois/poi-temperature.png',
        CLOSED: 'openlayers/icons/pois/poi-closed.png',
        EVENT_TICKET: 'openlayers/icons/events/event-ticket.png',
        EVENT_SPORT: 'openlayers/icons/events/event-sport.png',
        EVENT_FOOTBALL: 'openlayers/icons/events/event-football.png',
        EVENT_HOCKEY: 'openlayers/icons/events/event-hockey.png',
        EVENT_BASKETBALL: 'openlayers/icons/events/event-basketball.png',
        EVENT_MUSIC: 'openlayers/icons/events/event-music.png',
        EVENT_THEATER: 'openlayers/icons/events/event-theater.png',
    },
    AOIS: {
        IMPORTANT: 'openlayers/icons/aois/important-area.png',
        WARNINGS: 'openlayers/icons/aois/closed-area.png',
        INFO: 'openlayers/icons/aois/area.png',

    },
    GPS_POSITION: 'openlayers/gps-position.png',
    DIRECTION_ARROW: 'openlayers/direction-arrow.png',
};

const PROPS = {
    PATHS: {
        DIFFICULTY: {
            veryEasy: COLORS.DIFFICULTY.VERY_EASY,
            easy: COLORS.DIFFICULTY.EASY,
            medium: COLORS.DIFFICULTY.MEDIUM,
            hard: COLORS.DIFFICULTY.HARD,
        },

        CATEGORY_1: {
            color: COLORS.PATHS.CROSS_COUNTRY_SKIING,
            icon: ICONS.PATHS.CROSS_COUNTRY_SKIING,
            closedIcon: ICONS.PATHS.CROSS_COUNTRY_SKIING_CLOSED,
        },
        CATEGORY_2: {
            color: COLORS.PATHS.SNOWMOBILING,
            icon: ICONS.PATHS.SNOWMOBILING,
            closedIcon: ICONS.PATHS.SNOWMOBILING,
        },
        CATEGORY_3: {
            color: COLORS.PATHS.MOUNTAIN_BIKING,
            icon: ICONS.PATHS.MOUNTAIN_BIKING,
            closedIcon: ICONS.PATHS.MOUNTAIN_BIKING,
        },
        CATEGORY_4: {
            color: COLORS.PATHS.HIKING,
            icon: ICONS.PATHS.HIKING,
            closedIcon: ICONS.PATHS.HIKING,
        },
        CATEGORY_5: {
            color: COLORS.PATHS.RUNNING,
            icon: ICONS.PATHS.RUNNING,
            closedIcon: ICONS.PATHS.RUNNING,
        },
        CATEGORY_6: {
            color: COLORS.PATHS.RIDING,
            icon: ICONS.PATHS.RIDING,
            closedIcon: ICONS.PATHS.RIDING,
        },
        CATEGORY_7: {
            color: COLORS.PATHS.CANOE,
            icon: ICONS.PATHS.CANOE,
            closedIcon: ICONS.PATHS.CANOE,
        },
        CATEGORY_8: {
            color: COLORS.PATHS.CHAIR_LIFT,
            icon: ICONS.PATHS.CHAIR_LIFT,
            closedIcon: ICONS.PATHS.CHAIR_LIFT,
        },
        CATEGORY_9: {
            color: COLORS.PATHS.GONDOLA,
            icon: ICONS.PATHS.GONDOLA,
            closedIcon: ICONS.PATHS.GONDOLA,
        },
        CATEGORY_10: {
            color: COLORS.PATHS.SURFACE_LIFT,
            icon: ICONS.PATHS.SURFACE_LIFT,
            closedIcon: ICONS.PATHS.SURFACE_LIFT,
        },
        CATEGORY_11: {
            color: COLORS.PATHS.BELT_LIFT,
            icon: ICONS.PATHS.BELT_LIFT,
            closedIcon: ICONS.PATHS.BELT_LIFT,
        },
        CATEGORY_12: {
            color: COLORS.PATHS.SKI_SLOPE,
            icon: ICONS.PATHS.SKI_SLOPE,
            closedIcon: ICONS.PATHS.SKI_SLOPE,
        },
    },
    POIS: {
        POI_CATEGORY_1: {
            color: COLORS.POIS.RESTAURANT,
            icon: ICONS.POIS.RESTAURANT,
            closedIcon: ICONS.POIS.RESTAURANT,
        },
        POI_CATEGORY_2: {
            color: COLORS.POIS.CAFES,
            icon: ICONS.POIS.CAFES,
            closedIcon: ICONS.POIS.CAFES,
        },
        POI_CATEGORY_3: {
            color: COLORS.POIS.ATTRACTIONS,
            icon: ICONS.POIS.PLACE_OF_INTERESTS,
            closedIcon: ICONS.POIS.PLACE_OF_INTERESTS,
        },
        POI_CATEGORY_4: {
            color: COLORS.POIS.LOOKOUTS,
            icon: ICONS.POIS.LOOKOUTS,
            closedIcon: ICONS.POIS.LOOKOUTS,
        },
        POI_CATEGORY_5: {
            color: COLORS.POIS.PARKING,
            icon: ICONS.POIS.PARKING,
            closedIcon: ICONS.POIS.PARKING,
        },
        POI_CATEGORY_6: {
            color: COLORS.POIS.CABINS,
            icon: ICONS.POIS.CABINS,
            closedIcon: ICONS.POIS.CABINS,
        },
        POI_CATEGORY_7: {
            color: COLORS.POIS.SKI_BUS,
            icon: ICONS.POIS.SKI_BUS,
            closedIcon: ICONS.POIS.SKI_BUS,
        },
        POI_CATEGORY_8: {
            // TODO: Allocate a separate color for shelters?
            color: COLORS.POIS.SHELTER,
            icon: ICONS.POIS.SHELTER,
            closedIcon: ICONS.POIS.SHELTER,
        },
        POI_CATEGORY_9: {
            color: COLORS.POIS.STORES,
            icon: ICONS.POIS.STORES,
            closedIcon: ICONS.POIS.STORES,
        },
        POI_CATEGORY_10: {
            color: COLORS.POIS.ATTRACTIONS,
            icon: ICONS.POIS.ATTRACTIONS,
            closedIcon: ICONS.POIS.ATTRACTIONS,
        },
        POI_CATEGORY_11: {
            color: COLORS.POIS.ICE_RINK,
            icon: ICONS.POIS.ICE_RINK,
            closedIcon: ICONS.POIS.ICE_RINK,
        },
        POI_CATEGORY_12: {
            color: COLORS.POIS.STORES,
            icon: ICONS.POIS.STORES,
            closedIcon: ICONS.POIS.STORES,
        },
        POI_CATEGORY_13: {
            color: COLORS.POIS.STORES,
            icon: ICONS.POIS.STORES,
            closedIcon: ICONS.POIS.STORES,
        },
        POI_CATEGORY_14: {
            color: COLORS.POIS.TOILETS,
            icon: ICONS.POIS.TOILETS,
            closedIcon: ICONS.POIS.TOILETS,
        },
        POI_CATEGORY_15: {
            color: COLORS.POIS.ATTRACTIONS,
            icon: ICONS.POIS.ATTRACTIONS,
            closedIcon: ICONS.POIS.ATTRACTIONS,
        },
        POI_CATEGORY_16: {
            color: COLORS.POIS.WARNING,
            icon: ICONS.POIS.WARNINGS,
            closedIcon: ICONS.POIS.WARNINGS,
        },
        POI_CATEGORY_17: {
            color: COLORS.POIS.SWIMMING_PLACES,
            icon: ICONS.POIS.SWIMMING_PLACES,
            closedIcon: ICONS.POIS.SWIMMING_PLACES,
        },
        POI_CATEGORY_18: {
            color: COLORS.POIS.ICE_RINK,
            icon: ICONS.POIS.ICE_RINK,
            closedIcon: ICONS.POIS.ICE_RINK,
        },
        POI_CATEGORY_19: {
            color: COLORS.POIS.TEMPERATURE,
            icon: ICONS.POIS.TEMPERATURE,
            closedIcon: ICONS.POIS.TEMPERATURE,
        },
        TICKET: {
            color: COLORS.POIS.DEFAULT,
            icon: ICONS.POIS.EVENT_TICKET,
            closedIcon: ICONS.POIS.EVENT_TICKET,
        },
        SPORT: {
            color: COLORS.POIS.DEFAULT,
            icon: ICONS.POIS.EVENT_SPORT,
            closedIcon: ICONS.POIS.EVENT_SPORT,
        },
        FOOTBALL: {
            color: COLORS.POIS.DEFAULT,
            icon: ICONS.POIS.EVENT_FOOTBALL,
            closedIcon: ICONS.POIS.EVENT_FOOTBALL,
        },
        HOCKEY: {
            color: COLORS.POIS.DEFAULT,
            icon: ICONS.POIS.EVENT_HOCKEY,
            closedIcon: ICONS.POIS.EVENT_HOCKEY,
        },
        BASKETBALL: {
            color: COLORS.POIS.DEFAULT,
            icon: ICONS.POIS.EVENT_BASKETBALL,
            closedIcon: ICONS.POIS.EVENT_BASKETBALL,
        },
        MUSIC: {
            color: COLORS.POIS.DEFAULT,
            icon: ICONS.POIS.EVENT_MUSIC,
            closedIcon: ICONS.POIS.EVENT_MUSIC,
        },
        THEATER: {
            color: COLORS.POIS.DEFAULT,
            icon: ICONS.POIS.EVENT_THEATER,
            closedIcon: ICONS.POIS.EVENT_THEATER,
        },
        EVENT_TICKET: {
            color: COLORS.POIS.DEFAULT,
            icon: ICONS.POIS.EVENT_TICKET,
            closedIcon: ICONS.POIS.EVENT_TICKET,
        },
        EVENT_SPORT: {
            color: COLORS.POIS.DEFAULT,
            icon: ICONS.POIS.EVENT_SPORT,
            closedIcon: ICONS.POIS.EVENT_SPORT,
        },
        EVENT_FOOTBALL: {
            color: COLORS.POIS.DEFAULT,
            icon: ICONS.POIS.EVENT_FOOTBALL,
            closedIcon: ICONS.POIS.EVENT_FOOTBALL,
        },
        EVENT_HOCKEY: {
            color: COLORS.POIS.DEFAULT,
            icon: ICONS.POIS.EVENT_HOCKEY,
            closedIcon: ICONS.POIS.EVENT_HOCKEY,
        },
        EVENT_BASKETBALL: {
            color: COLORS.POIS.DEFAULT,
            icon: ICONS.POIS.EVENT_BASKETBALL,
            closedIcon: ICONS.POIS.EVENT_BASKETBALL,
        },
        EVENT_MUSIC: {
            color: COLORS.POIS.DEFAULT,
            icon: ICONS.POIS.EVENT_MUSIC,
            closedIcon: ICONS.POIS.EVENT_MUSIC,
        },
        EVENT_THEATER: {
            color: COLORS.POIS.DEFAULT,
            icon: ICONS.POIS.EVENT_THEATER,
            closedIcon: ICONS.POIS.EVENT_THEATER,
        },
        EVENT_ICON_TICKET: {
            color: COLORS.POIS.DEFAULT,
            icon: ICONS.POIS.EVENT_TICKET,
            closedIcon: ICONS.POIS.EVENT_TICKET,
        },
        EVENT_ICON_SPORT: {
            color: COLORS.POIS.DEFAULT,
            icon: ICONS.POIS.EVENT_SPORT,
            closedIcon: ICONS.POIS.EVENT_SPORT,
        },
        EVENT_ICON_FOOTBALL: {
            color: COLORS.POIS.DEFAULT,
            icon: ICONS.POIS.EVENT_FOOTBALL,
            closedIcon: ICONS.POIS.EVENT_FOOTBALL,
        },
        EVENT_ICON_HOCKEY: {
            color: COLORS.POIS.DEFAULT,
            icon: ICONS.POIS.EVENT_HOCKEY,
            closedIcon: ICONS.POIS.EVENT_HOCKEY,
        },
        EVENT_ICON_BASKETBALL: {
            color: COLORS.POIS.DEFAULT,
            icon: ICONS.POIS.EVENT_BASKETBALL,
            closedIcon: ICONS.POIS.EVENT_BASKETBALL,
        },
        EVENT_ICON_MUSIC: {
            color: COLORS.POIS.DEFAULT,
            icon: ICONS.POIS.EVENT_MUSIC,
            closedIcon: ICONS.POIS.EVENT_MUSIC,
        },
        EVENT_ICON_THEATER: {
            color: COLORS.POIS.DEFAULT,
            icon: ICONS.POIS.EVENT_THEATER,
            closedIcon: ICONS.POIS.EVENT_THEATER,
        },
    },
    AOIS: {
        AOI_CATEGORY_1: {
            color: COLORS.AOIS.WARNING_AREA,
            icon: ICONS.AOIS.WARNINGS,
            closedIcon: ICONS.POIS.RESTAURANT,
        },
        AOI_CATEGORY_2: {
            color: COLORS.AOIS.IMPORTANT_AREA,
            icon: ICONS.AOIS.IMPORTANT,
            closedIcon: ICONS.AOIS.IMPORTANT,
        },
        AOI_CATEGORY_3: {
            color: COLORS.AOIS.INFO_AREA,
            icon: ICONS.AOIS.INFO,
            closedIcon: ICONS.AOIS.INFO,
        },
    }
};

const OBJECT_TYPE = 'objectType';
const OBJECT_ID = 'objectId';

export {
    MAPBOX_ACCESS_TOKEN,
    MAPBOX_STYLE_USER,
    MAPBOX_STYLE_ID,
    MAPBOX_3D_STYLE_USER,
    MAPBOX_3D_STYLE_ID,
    MAPBOX_SATELLITE_STYLE_USER,
    MAPBOX_SATELLITE_STYLE_ID,
    MAPBOX_3D_SATELLITE_STYLE_USER,
    MAPBOX_3D_SATELLITE_STYLE_ID,
    ICONS,
    PROPS,
    OBJECT_TYPE,
    OBJECT_ID,
};